import Control from "../../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROConseil = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });
  const activityKey = "conseil";
  return (
    <div>
      <Control
        label={inputsConfig.conseilTypeConseils.label}
        type="checkBtnList"
        name="conseilTypeConseils"
        value={company.RCPRO.conseilTypeConseils}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.conseilTypeConseils.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        info={<>Plusieurs réponses possibles</>}
        required
      />
      <Control
        label={inputsConfig.conseilRecommandationsAppliqueesParClient.label}
        type="btnList"
        name="conseilRecommandationsAppliqueesParClient"
        value={company.RCPRO.conseilRecommandationsAppliqueesParClient}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.conseilRecommandationsAppliqueesParClient.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROConseil;
